import clsx from "clsx";
import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import {
  DropdownTemplate,
  NumberTemplate,
  SwitchTemplate,
} from "@ryde/controls";
import {
  AddBulkStationFormFieldsEnum,
  AddBulkStationMethodEnum,
  enumToSelectList,
  ISelectListItem,
  onActivateKeyDown,
} from "@ryde/shared";

import { usePassengerMapAddBulkStationsPanel } from "../../hooks";
import { PassengersAddBulkStationsPanelStyled } from "./passengers.map.styled";

const bulkAddStationMethodSelectedList: ISelectListItem[] = enumToSelectList(
  AddBulkStationMethodEnum,
);

interface IPassengersMapAddBulkStationsPanelProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const PassengersMapAddBulkStationsPanel: FC<
  IPassengersMapAddBulkStationsPanelProps
> = ({ isOpen, handleClose }) => {
  const { methods, isDisabled, handleClick } =
    usePassengerMapAddBulkStationsPanel();

  const { setValue, watch } = methods;

  const watchedMethodField = watch(AddBulkStationFormFieldsEnum.method);

  const valueLabelTranslatePath =
    watchedMethodField === AddBulkStationMethodEnum.distanceInMeters
      ? "general.Meters"
      : "general.Minutes";

  const { t } = useTranslation();

  return (
    isOpen && (
      <FormProvider {...methods}>
        <PassengersAddBulkStationsPanelStyled>
          <div>
            <div className="dropdownsContainer">
              <div className="dropdownInput">
                <DropdownTemplate
                  name={AddBulkStationFormFieldsEnum.method}
                  labelTranslated={t("station.selectDistanceMethod")}
                  formAttributes={{
                    selectItems: bulkAddStationMethodSelectedList,
                  }}
                />
              </div>
              <div className="input">
                <NumberTemplate
                  name={AddBulkStationFormFieldsEnum.value}
                  labelTranslated={t(valueLabelTranslatePath)}
                />
              </div>
            </div>

            <div className="switchInput">
              <SwitchTemplate
                name={AddBulkStationFormFieldsEnum.isSetOnlyForMissingPickup}
                labelTranslated={t("station.isSetOnlyForMissingPickup")}
              />
            </div>
          </div>

          <div className="actionsButtons">
            <div
              onClick={handleClick}
              onKeyDown={onActivateKeyDown(handleClick)}
              role="button"
              tabIndex={0}
              className={clsx("saveButton", { disabled: isDisabled })}
            >
              {t("general.assign")}
            </div>

            <PIC.XSVG className="close-icon-svg" onClick={handleClose} />
          </div>
        </PassengersAddBulkStationsPanelStyled>
      </FormProvider>
    )
  );
};
